import { Email } from '@shared/icons';
import { useTranslations } from 'next-intl';
import type { ComponentProps } from 'react';
import { InnerPageContainer } from '../../../InnerPageContainer/InnerPageContainer';
import { NoResults } from '../../../NoResults/NoResults';
import { InboxMessageLoader } from '../InboxMessageLoader/InboxMessageLoader';
import { InboxPageHeader } from '../InboxPageHeader/InboxPageHeader';
import { InboxSkeleton } from '../InboxSkeleton/InboxSkeleton';

type InboxLayoutComponentProps = ComponentProps<'div'>;

/**
 * Layout shared component for the inbox page, to be used in the apps.
 * @param children - the children to render
 * @returns the inbox layout component
 */
function InboxLayoutComponent({ children, ...props }: InboxLayoutComponentProps) {
  const t = useTranslations('my_account.inbox');

  return (
    <div className="ll-grid-container" data-track-container="Inbox" {...props}>
      <InboxPageHeader />
      <InnerPageContainer className="ll-container-full">
        <div className="ll-grid-container gap-y-7 pt-4 pb-20 sm-md:pt-10 sm-md:[--ll-container-padding:40px]">
          <div className="ll-container-inner">
            <InboxMessageLoader
              loadingFallback={<InboxSkeleton />}
              errorFallback={<NoResults title={t('empty_state.title')} description={t('empty_state.description')} icon={Email} />}
            >
              {children}
            </InboxMessageLoader>
          </div>
        </div>
      </InnerPageContainer>
    </div>
  );
}

export { InboxLayoutComponent };
